<router-outlet></router-outlet>
<tour-step-template>
  <ng-template let-step="step">
    <mat-card style="z-index: 999"
              (click)="$event.stopPropagation()"
              [style.width]="step.stepDimensions?.width"
              [style.min-width]="step.stepDimensions?.minWidth"
              [style.max-width]="step.stepDimensions?.maxWidth">

      <div class="progress">
        <div class="button-close">
          <button mat-icon-button (click)="accountSetupWizardService.cancelTour()" class="close">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="steps">
          {{ accountSetupWizardService.tour.steps.indexOf(step) + 1 }}
          /
          {{ accountSetupWizardService.tour.steps.length }}
        </div>
      </div>

      <mat-card-header>
        <div class="header-group">
          <mat-card-title>{{ step.title }}</mat-card-title>
        </div>
      </mat-card-header>

      <mat-card-content class="mat-body" [innerHTML]="step.content"></mat-card-content>

        <div
          *ngIf="step.stepId?.endsWith('-0')"
          class="end-with-zero">
          <button
            (click)="accountSetupWizardService.tour.next()">
            {{ step.nextBtnTitle || 'Pokračovať' }}
          </button>
        </div>
    </mat-card>
  </ng-template>
</tour-step-template>
